import axiosInstance from '../auth/axiosInstance';

export const getIndustries = async (params = {}) => {
  try {
    const {
      searchTerm = '',
      isActive = true,
      page = 1,
      pageSize = 10,
      sort = ''
    } = params;

    const queryParams = new URLSearchParams({
      ...(searchTerm && { searchTerm }),
      ...(sort && { sort }),
      isActive: isActive.toString(),
      page: page.toString(),
      pageSize: pageSize.toString()
    });

    const apiPath = `/CostEstimation/GetIndustries?${queryParams}`;
    console.log('Fetching industries from URL:', apiPath);
    const { data: result, status: responseStatus } = await axiosInstance.get(apiPath);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch industries: ${response.status} ${response.statusText}`);
    }


    console.log('GetIndustries response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching industries:', error);
    throw error;
  }
};

// Get Industry by ID API
export const getIndustryById = async (id) => {
  try {
    // Validate parameter
    if (!id || !Number.isInteger(id) || id <= 0) {
      throw new Error('Invalid id: must be a positive integer');
    }

    const apiPath = `/CostEstimation/GetIndustry/${id}`;
    console.log('Fetching industry by ID from URL:', apiPath);    console.log('Industry ID being requested:', id);
    const { data: result, status: responseStatus } = await axiosInstance.get(apiPath);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (response.status === 404) {
      throw new Error('Industry not found');
    }

    if (response.status === 500) {
      // Try to get more details about the 500 error
      let errorDetails = '';
      try {
        const errorResponse = await response.text();
        errorDetails = errorResponse;
        console.error('500 Error details:', errorResponse);
      } catch (e) {
        console.error('Could not parse error response:', e);
      }
      throw new Error(`Server error (500): ${errorDetails || 'Internal server error'}`);
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch industry: ${response.status} ${response.statusText}`);
    }


    console.log('GetIndustryById response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching industry by ID:', error);
    throw error;
  }
};

// Add or Update Industry API
export const addOrUpdateIndustry = async (industryData) => {
  try {
    // Validate required fields
    if (!industryData) {
      throw new Error('Industry data is required');
    }

    const { id, name, code, isActive } = industryData;

    if (!name || typeof name !== 'string' || name.trim() === '') {
      throw new Error('Name is required and must be a non-empty string');
    }

    if (!code || typeof code !== 'string' || code.trim() === '') {
      throw new Error('Code is required and must be a non-empty string');
    }

    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }

    const apiPath = '/CostEstimation/AddOrUpdateIndustry';
    console.log('Adding/Updating industry at URL:', apiPath);
    console.log('Industry data:', industryData);
    const { data: result, status: responseStatus } = await axiosInstance.post(apiPath, {
        id: id || 0,
        name: name.trim(),
        code: code.trim().toUpperCase(),
        isActive: isActive
      });
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to add/update industry: ${response.status} ${response.statusText}`);
    }


    console.log('AddOrUpdateIndustry response:', result);
    return result;
  } catch (error) {
    console.error('Error adding/updating industry:', error);
    throw error;
  }
};

// Delete Industry API
export const deleteIndustry = async (id) => {
  try {
    // Validate parameter
    if (!id || !Number.isInteger(id) || id <= 0) {
      throw new Error('Invalid id: must be a positive integer');
    }

    const apiPath = `/CostEstimation/DeleteIndustry/${id}`;
    console.log('Deleting industry at URL:', apiPath);
    console.log('Industry ID to delete:', id);
    const { data, status } = await axiosInstance.delete(apiPath);

    if (status === 204 || data == null || data === '') {
      return { success: true, message: 'Industry deleted successfully' };
    }

    console.log('DeleteIndustry response:', data);
    return data;
  } catch (error) {
    console.error('Error deleting industry:', error);
    throw error;
  }
};

// Get Sub Sectors API
export const getSubSectors = async (params = {}) => {
  try {
    const {
      industryId,
      searchTerm = '',
      isActive = true,
      page = 1,
      pageSize = 10,
      sort = ''
    } = params;

    // Validate required parameter
    if (!industryId || !Number.isInteger(industryId) || industryId <= 0) {
      throw new Error('industryId is required and must be a positive integer');
    }

    const queryParams = new URLSearchParams({
      industryId: industryId.toString(),
      ...(searchTerm && { searchTerm }),
      ...(sort && { sort }),
      isActive: isActive.toString(),
      page: page.toString(),
      pageSize: pageSize.toString()
    });

    const apiPath = `/CostEstimation/GetSubSectors?${queryParams}`;
    console.log('Fetching sub sectors from URL:', apiPath);    console.log('Sub Sectors params:', params);

    const { data: result, status: responseStatus } = await axiosInstance.get(apiPath);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch sub sectors: ${response.status} ${response.statusText}`);
    }


    console.log('GetSubSectors response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching sub sectors:', error);
    throw error;
  }
};

// Add or Update Sub Sector API
export const addOrUpdateSubSector = async (subSectorData) => {
  try {
    // Validate required fields
    if (!subSectorData) {
      throw new Error('Sub sector data is required');
    }

    const { id, industryId, name, code, isActive } = subSectorData;

    if (!industryId || !Number.isInteger(industryId) || industryId <= 0) {
      throw new Error('industryId is required and must be a positive integer');
    }

    if (!name || typeof name !== 'string' || name.trim() === '') {
      throw new Error('Name is required and must be a non-empty string');
    }

    if (!code || typeof code !== 'string' || code.trim() === '') {
      throw new Error('Code is required and must be a non-empty string');
    }

    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }

    const apiPath = '/CostEstimation/AddOrUpdateSubSector';
    console.log('Adding/Updating sub sector at URL:', apiPath);
    console.log('Sub sector data:', subSectorData);
    const { data: result, status: responseStatus } = await axiosInstance.post(apiPath, {
        id: id || 0,
        industryId: industryId,
        name: name.trim(),
        code: code.trim().toUpperCase(),
        isActive: isActive
      });
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to add/update sub sector: ${response.status} ${response.statusText}`);
    }


    console.log('AddOrUpdateSubSector response:', result);
    return result;
  } catch (error) {
    console.error('Error adding/updating sub sector:', error);
    throw error;
  }
};

// Delete Sub Sector API
export const deleteSubSector = async (id) => {
  try {
    // Validate parameter
    if (!id || !Number.isInteger(id) || id <= 0) {
      throw new Error('Invalid id: must be a positive integer');
    }

    const apiPath = `/CostEstimation/DeleteSubSector/${id}`;
    console.log('Deleting sub sector at URL:', apiPath);
    console.log('Sub sector ID to delete:', id);
    const { data, status } = await axiosInstance.delete(apiPath);

    if (status === 204 || data == null || data === '') {
      return { success: true, message: 'Sub sector deleted successfully' };
    }

    console.log('DeleteSubSector response:', data);
    return data;
  } catch (error) {
    console.error('Error deleting sub sector:', error);
    throw error;
  }
};

// Get Business Functions API
export const getBusinessFunctions = async (params = {}) => {
  try {
    const {
      searchTerm = '',
      isActive = true,
      page = 1,
      pageSize = 10,
      sort = ''
    } = params;

    const queryParams = new URLSearchParams({
      ...(searchTerm && { searchTerm }),
      ...(sort && { sort }),
      isActive: isActive.toString(),
      page: page.toString(),
      pageSize: pageSize.toString()
    });

    const apiPath = `/CostEstimation/GetBusinessFunctions?${queryParams}`;
    console.log('Fetching business functions from URL:', apiPath);
    const { data: result, status: responseStatus } = await axiosInstance.get(apiPath);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch business functions: ${response.status} ${response.statusText}`);
    }


    console.log('GetBusinessFunctions response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching business functions:', error);
    throw error;
  }
};

// Add or Update Business Function API
export const addOrUpdateBusinessFunction = async (businessFunctionData) => {
  try {
    // Validate required fields
    if (!businessFunctionData) {
      throw new Error('Business function data is required');
    }

    const { id, name, code, isActive, subBusinessFunctions = [] } = businessFunctionData;

    if (!name || typeof name !== 'string' || name.trim() === '') {
      throw new Error('Name is required and must be a non-empty string');
    }

    if (!code || typeof code !== 'string' || code.trim() === '') {
      throw new Error('Code is required and must be a non-empty string');
    }

    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }

    // Validate subBusinessFunctions if provided
    if (subBusinessFunctions && !Array.isArray(subBusinessFunctions)) {
      throw new Error('subBusinessFunctions must be an array');
    }

    // Validate each subBusinessFunction
    if (subBusinessFunctions && subBusinessFunctions.length > 0) {
      for (let i = 0; i < subBusinessFunctions.length; i++) {
        const subFunc = subBusinessFunctions[i];
        if (!subFunc.name || typeof subFunc.name !== 'string' || subFunc.name.trim() === '') {
          throw new Error(`SubBusinessFunction at index ${i}: name is required and must be a non-empty string`);
        }
        if (!subFunc.code || typeof subFunc.code !== 'string' || subFunc.code.trim() === '') {
          throw new Error(`SubBusinessFunction at index ${i}: code is required and must be a non-empty string`);
        }
        if (typeof subFunc.isActive !== 'boolean') {
          throw new Error(`SubBusinessFunction at index ${i}: isActive must be a boolean value`);
        }
      }
    }

    const apiPath = '/CostEstimation/AddOrUpdateBusinessFunction';
    console.log('Adding/Updating business function at URL:', apiPath);
    console.log('Business function data:', businessFunctionData);
    // Prepare request body with subBusinessFunctions
    const requestBody = {
      id: id || 0,
      name: name.trim(),
      code: code.trim().toUpperCase(),
      isActive: isActive,
      subBusinessFunctions: subBusinessFunctions.map(subFunc => ({
        id: subFunc.id || 0,
        businessFunctionId: id || 0, // Will be set by the server for new records
        name: subFunc.name.trim(),
        code: subFunc.code.trim().toUpperCase(),
        isActive: subFunc.isActive
      }))
    };

    const { data: result, status: responseStatus } = await axiosInstance.post(apiPath, requestBody);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to add/update business function: ${response.status} ${response.statusText}`);
    }


    console.log('AddOrUpdateBusinessFunction response:', result);

    // Transform response to match the expected structure
    const transformedResult = {
      id: result.id || result.data?.id || 0,
      name: result.name || result.data?.name || name.trim(),
      code: result.code || result.data?.code || code.trim().toUpperCase(),
      isActive: result.isActive !== undefined ? result.isActive : (result.data?.isActive !== undefined ? result.data.isActive : isActive),
      subBusinessFunctions: result.subBusinessFunctions || result.data?.subBusinessFunctions || []
    };

    console.log('Transformed AddOrUpdateBusinessFunction response:', transformedResult);
    return transformedResult;
  } catch (error) {
    console.error('Error adding/updating business function:', error);
    throw error;
  }
};

// Delete Business Function API
export const deleteBusinessFunction = async (id, isSubFunction = false) => {
  try {
    // Validate parameter
    if (!id || !Number.isInteger(id) || id <= 0) {
      throw new Error('Invalid id: must be a positive integer');
    }

    const queryParams = new URLSearchParams({
      isSubFunction: isSubFunction.toString()
    });

    const apiPath = `/CostEstimation/DeleteBusinessFunction/${id}?${queryParams}`;
    console.log('Deleting business function at URL:', apiPath);
    console.log('Business function ID to delete:', id);
    console.log('Is sub function:', isSubFunction);
    const { data, status } = await axiosInstance.delete(apiPath);

    if (status === 204 || data == null || data === '') {
      return { success: true, message: 'Business function deleted successfully' };
    }

    console.log('DeleteBusinessFunction response:', data);
    return data;
  } catch (error) {
    console.error('Error deleting business function:', error);
    throw error;
  }
};
// Get Data AI Value Levers API
export const getDataAIValueLevers = async (params = {}) => {
  try {
    const {
      searchTerm = '',
      isActive = true,
      page = 1,
      pageSize = 100,
      sort = ''
    } = params;

    const queryParams = new URLSearchParams({
      ...(searchTerm && { searchTerm }),
      ...(sort && { sort }),
      isActive: isActive.toString(),
      page: page.toString(),
      pageSize: pageSize.toString()
    });

    const apiPath = `/CostEstimation/GetDataAIValueLevers?${queryParams}`;
    console.log('Fetching Data AI Value Levers from URL:', apiPath);    console.log('Data AI Value Levers params:', params);

    const { data: result, status: responseStatus } = await axiosInstance.get(apiPath);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch Data AI Value Levers: ${response.status} ${response.statusText}`);
    }


    console.log('GetDataAIValueLevers response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching Data AI Value Levers:', error);
    throw error;
  }
};

// Add or Update Data AI Value Lever API
export const addOrUpdateDataAIValueLever = async (dataAIValueLeverData) => {
  try {
    // Validate required fields
    if (!dataAIValueLeverData) {
      throw new Error('Data AI Value Lever data is required');
    }

    const { id, name, description, isActive, dataAIValueSubLevers = [] } = dataAIValueLeverData;

    if (!name || typeof name !== 'string' || name.trim() === '') {
      throw new Error('Name is required and must be a non-empty string');
    }

    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }

    // Validate dataAIValueSubLevers if provided
    if (dataAIValueSubLevers && !Array.isArray(dataAIValueSubLevers)) {
      throw new Error('dataAIValueSubLevers must be an array');
    }

    // Validate each sub-lever
    if (dataAIValueSubLevers && dataAIValueSubLevers.length > 0) {
      for (let i = 0; i < dataAIValueSubLevers.length; i++) {
        const subLever = dataAIValueSubLevers[i];
        if (!subLever.name || typeof subLever.name !== 'string' || subLever.name.trim() === '') {
          throw new Error(`Sub-lever at index ${i}: name is required and must be a non-empty string`);
        }
        if (typeof subLever.isActive !== 'boolean') {
          throw new Error(`Sub-lever at index ${i}: isActive must be a boolean value`);
        }
      }
    }

    const apiPath = '/CostEstimation/AddOrUpdateDataAIValueLever';
    console.log('Adding/Updating Data AI Value Lever at URL:', apiPath);
    console.log('Data AI Value Lever data:', dataAIValueLeverData);
    const requestBody = {
      id: id || 0,
      name: name.trim(),
      description: description ? description.trim() : '',
      isActive: isActive,
      dataAIValueSubLevers: dataAIValueSubLevers.map(subLever => ({
        id: subLever.id || 0,
        dataAIValueLeverId: id || 0, // Will be set by the server for new records
        name: subLever.name.trim(),
        description: subLever.description ? subLever.description.trim() : '',
        isActive: subLever.isActive
      }))
    };

    const { data: result, status: responseStatus } = await axiosInstance.post(apiPath, requestBody);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to add/update Data AI Value Lever: ${response.status} ${response.statusText}`);
    }


    console.log('AddOrUpdateDataAIValueLever response:', result);
    return result;
  } catch (error) {
    console.error('Error adding/updating Data AI Value Lever:', error);
    throw error;
  }
};

// Delete Data AI Value Lever API
export const deleteDataAIValueLever = async (id, isSubLever = false) => {
  console.log('deleteDataAIValueLever API function called with ID:', id, 'Type:', typeof id, 'isSubLever:', isSubLever);
  try {
    // Validate required fields
    if (!id || !Number.isInteger(id) || id <= 0) {
      console.error('Invalid ID provided to deleteDataAIValueLever:', id);
      throw new Error('ID is required and must be a positive integer');
    }

    const queryParams = new URLSearchParams({
      isSubLever: isSubLever.toString()
    });

    const apiPath = `/CostEstimation/DeleteDataAIValueLever/${id}?${queryParams}`;
    console.log('Deleting Data AI Value Lever at URL:', apiPath);
    console.log('Data AI Value Lever ID:', id);
    console.log('Is Sub Lever:', isSubLever);
    console.log('Making DELETE request to:', apiPath);
    const { data, status } = await axiosInstance.delete(apiPath);

    if (status === 204 || data == null || data === '') {
      return { success: true, message: 'Data AI Value Lever deleted successfully' };
    }

    console.log('DeleteDataAIValueLever response:', data);
    return data;
  } catch (error) {
    console.error('Error deleting Data AI Value Lever:', error);
    throw error;
  }
};

// Get Business Value Drivers API
export const getBusinessValueDrivers = async (params = {}) => {
  try {
    const {
      searchTerm = '',
      isActive = true,
      page = 1,
      pageSize = 100,
      sort = ''
    } = params;

    const queryParams = new URLSearchParams({
      ...(searchTerm && { searchTerm }),
      ...(sort && { sort }),
      isActive: isActive.toString(),
      page: page.toString(),
      pageSize: pageSize.toString()
    });

    const apiPath = `/CostEstimation/GetBusinessValueDrivers?${queryParams}`;
    console.log('Fetching Business Value Drivers from URL:', apiPath);    console.log('Business Value Drivers params:', params);

    const { data: result, status: responseStatus } = await axiosInstance.get(apiPath);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch Business Value Drivers: ${response.status} ${response.statusText}`);
    }


    console.log('GetBusinessValueDrivers response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching Business Value Drivers:', error);
    throw error;
  }
};

// Add or Update Business Value Driver API
export const addOrUpdateBusinessValueDriver = async (businessValueDriverData) => {
  try {
    // Validate required fields
    if (!businessValueDriverData) {
      throw new Error('Business Value Driver data is required');
    }

    const { id, name, description, isActive, businessSubValueDrivers = [] } = businessValueDriverData;

    if (!name || typeof name !== 'string' || name.trim() === '') {
      throw new Error('Name is required and must be a non-empty string');
    }

    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }

    // Validate businessSubValueDrivers if provided
    if (businessSubValueDrivers && !Array.isArray(businessSubValueDrivers)) {
      throw new Error('businessSubValueDrivers must be an array');
    }

    // Validate each sub-driver
    if (businessSubValueDrivers && businessSubValueDrivers.length > 0) {
      for (let i = 0; i < businessSubValueDrivers.length; i++) {
        const subDriver = businessSubValueDrivers[i];
        if (!subDriver.name || typeof subDriver.name !== 'string' || subDriver.name.trim() === '') {
          throw new Error(`Sub-driver at index ${i}: name is required and must be a non-empty string`);
        }
        if (typeof subDriver.isActive !== 'boolean') {
          throw new Error(`Sub-driver at index ${i}: isActive must be a boolean value`);
        }
      }
    }

    const apiPath = '/CostEstimation/AddOrUpdateBusinessValueDriver';
    console.log('Adding/Updating Business Value Driver at URL:', apiPath);
    console.log('Business Value Driver data:', businessValueDriverData);
    // Prepare request body
    const requestBody = {
      id: id || 0,
      name: name.trim(),
      description: description ? description.trim() : '',
      isActive: isActive,
      businessSubValueDrivers: businessSubValueDrivers.map(subDriver => ({
        id: subDriver.id || 0,
        businessValueDriverId: id || 0, // Will be set by the server for new records
        name: subDriver.name.trim(),
        description: subDriver.description ? subDriver.description.trim() : '',
        isActive: subDriver.isActive
      }))
    };

    const { data: result, status: responseStatus } = await axiosInstance.post(apiPath, requestBody);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to add/update Business Value Driver: ${response.status} ${response.statusText}`);
    }


    console.log('AddOrUpdateBusinessValueDriver response:', result);
    return result;
  } catch (error) {
    console.error('Error adding/updating Business Value Driver:', error);
    throw error;
  }
};

// Delete Business Value Driver API
export const deleteBusinessValueDriver = async (id, isSubDriver = false) => {
  try {
    // Validate parameter
    if (!id || !Number.isInteger(id) || id <= 0) {
      throw new Error('Invalid id: must be a positive integer');
    }

    const queryParams = new URLSearchParams({
      isSubDriver: isSubDriver.toString()
    });

    const apiPath = `/CostEstimation/DeleteBusinessValueDriver/${id}?${queryParams}`;
    console.log('Deleting Business Value Driver at URL:', apiPath);
    console.log('Business Value Driver ID to delete:', id);
    console.log('Is Sub Driver:', isSubDriver);
    const { data, status } = await axiosInstance.delete(apiPath);

    if (status === 204 || data == null || data === '') {
      return { success: true, message: 'Business Value Driver deleted successfully' };
    }

    console.log('DeleteBusinessValueDriver response:', data);
    return data;
  } catch (error) {
    console.error('Error deleting Business Value Driver:', error);
    throw error;
  }
};

// Get Functional Value Drivers API
export const getFunctionalValueDrivers = async (params = {}) => {
  try {
    const {
      searchTerm = '',
      isActive = true,
      page = 1,
      pageSize = 100,
      sort = ''
    } = params;

    const queryParams = new URLSearchParams({
      ...(searchTerm && { searchTerm }),
      ...(sort && { sort }),
      isActive: isActive.toString(),
      page: page.toString(),
      pageSize: pageSize.toString()
    });

    const apiPath = `/CostEstimation/GetFunctionalValueDrivers?${queryParams}`;
    console.log('Fetching Functional Value Drivers from URL:', apiPath);    console.log('Functional Value Drivers params:', params);

    const { data: result, status: responseStatus } = await axiosInstance.get(apiPath);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch Functional Value Drivers: ${response.status} ${response.statusText}`);
    }


    console.log('GetFunctionalValueDrivers response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching Functional Value Drivers:', error);
    throw error;
  }
};

// Add or Update Functional Value Driver API
export const addOrUpdateFunctionalValueDriver = async (functionalValueDriverData) => {
  try {
    // Validate required fields
    if (!functionalValueDriverData) {
      throw new Error('Functional Value Driver data is required');
    }

    const { id, name, description, isActive, functionalSubValueDrivers = [] } = functionalValueDriverData;

    if (!name || typeof name !== 'string' || name.trim() === '') {
      throw new Error('Name is required and must be a non-empty string');
    }

    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }

    // Validate functionalSubValueDrivers if provided
    if (functionalSubValueDrivers && !Array.isArray(functionalSubValueDrivers)) {
      throw new Error('functionalSubValueDrivers must be an array');
    }

    // Validate each sub-driver
    if (functionalSubValueDrivers && functionalSubValueDrivers.length > 0) {
      for (let i = 0; i < functionalSubValueDrivers.length; i++) {
        const subDriver = functionalSubValueDrivers[i];
        if (!subDriver.name || typeof subDriver.name !== 'string' || subDriver.name.trim() === '') {
          throw new Error(`Sub-driver at index ${i}: name is required and must be a non-empty string`);
        }
        if (typeof subDriver.isActive !== 'boolean') {
          throw new Error(`Sub-driver at index ${i}: isActive must be a boolean value`);
        }
      }
    }

    const apiPath = '/CostEstimation/AddOrUpdateFunctionalValueDriver';
    console.log('Adding/Updating Functional Value Driver at URL:', apiPath);
    console.log('Functional Value Driver data:', functionalValueDriverData);
    // Prepare request body
    const requestBody = {
      id: id || 0,
      name: name.trim(),
      description: description ? description.trim() : '',
      isActive: isActive,
      functionalSubValueDrivers: functionalSubValueDrivers.map(subDriver => ({
        id: subDriver.id || 0,
        functionalValueDriverId: id || 0, // Will be set by the server for new records
        name: subDriver.name.trim(),
        description: subDriver.description ? subDriver.description.trim() : '',
        isActive: subDriver.isActive
      }))
    };

    const { data: result, status: responseStatus } = await axiosInstance.post(apiPath, requestBody);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to add/update Functional Value Driver: ${response.status} ${response.statusText}`);
    }


    console.log('AddOrUpdateFunctionalValueDriver response:', result);
    return result;
  } catch (error) {
    console.error('Error adding/updating Functional Value Driver:', error);
    throw error;
  }
};

// Delete Functional Value Driver API
export const deleteFunctionalValueDriver = async (id, isSubDriver = false) => {
  try {
    // Validate parameter
    if (!id || !Number.isInteger(id) || id <= 0) {
      throw new Error('Invalid id: must be a positive integer');
    }

    const queryParams = new URLSearchParams({
      isSubDriver: isSubDriver.toString()
    });

    const apiPath = `/CostEstimation/DeleteFunctionalValueDriver/${id}?${queryParams}`;
    console.log('Deleting Functional Value Driver at URL:', apiPath);
    console.log('Functional Value Driver ID to delete:', id);
    console.log('Is Sub Driver:', isSubDriver);
    const { data, status } = await axiosInstance.delete(apiPath);

    if (status === 204 || data == null || data === '') {
      return { success: true, message: 'Functional Value Driver deleted successfully' };
    }

    console.log('DeleteFunctionalValueDriver response:', data);
    return data;
  } catch (error) {
    console.error('Error deleting Functional Value Driver:', error);
    throw error;
  }
};

// Get Use Cases API
export const getUseCases = async (params = {}) => {
  try {
    const {
      industryId,
      sectorId,
      functionId,
      subFunctionId,
      dataAILeverId,
      dataAISubLeverId,
      businessValueDriverId,
      businessSubValueDriverId,
      functionalValueDriverId,
      functionalSubValueDriverId,
      searchTerm = '',
      isActive = true,
      page = 1,
      pageSize = 100,
      sort = ''
    } = params;

    const queryParams = new URLSearchParams({
      ...(industryId && { industryId: industryId.toString() }),
      ...(sectorId && { sectorId: sectorId.toString() }),
      ...(functionId && { functionId: functionId.toString() }),
      ...(subFunctionId && { subFunctionId: subFunctionId.toString() }),
      ...(dataAILeverId && { dataAILeverId: dataAILeverId.toString() }),
      ...(dataAISubLeverId && { dataAISubLeverId: dataAISubLeverId.toString() }),
      ...(businessValueDriverId && { businessValueDriverId: businessValueDriverId.toString() }),
      ...(businessSubValueDriverId && { businessSubValueDriverId: businessSubValueDriverId.toString() }),
      ...(functionalValueDriverId && { functionalValueDriverId: functionalValueDriverId.toString() }),
      ...(functionalSubValueDriverId && { functionalSubValueDriverId: functionalSubValueDriverId.toString() }),
      ...(searchTerm && { searchTerm }),
      ...(sort && { sort }),
      isActive: isActive.toString(),
      page: page.toString(),
      pageSize: pageSize.toString()
    });

    const apiPath = `/CostEstimation/GetUseCases?${queryParams}`;
    console.log('Fetching Use Cases from URL:', apiPath);    console.log('Use Cases params:', params);

    const { data: result, status: responseStatus } = await axiosInstance.get(apiPath);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch Use Cases: ${response.status} ${response.statusText}`);
    }


    console.log('GetUseCases response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching Use Cases:', error);
    throw error;
  }
};

// Add or Update Use Case API
export const addOrUpdateUseCase = async (useCaseData) => {
  try {
    // Validate required fields
    if (!useCaseData) {
      throw new Error('Use case data is required');
    }

    const { 
      id, 
      caseId, 
      industryId, 
      sectorId, 
      functionId, 
      subFunctionId, 
      dataAILeverId, 
      dataAISubLeverId, 
      businessValueDriverId, 
      businessSubValueDriverId, 
      functionalValueDriverId, 
      functionalSubValueDriverId, 
      businessCapability, 
      dataAI, 
      title, 
      description, 
      dataCapability, 
      dataTechnicalCapability, 
      aiCapability, 
      aiTechnicalCapability, 
      improvementActions, 
      indicator, 
      isActive 
    } = useCaseData;

    // Validate required fields
    if (!caseId || typeof caseId !== 'string' || caseId.trim() === '') {
      throw new Error('Case ID is required and must be a non-empty string');
    }

    if (!title || typeof title !== 'string' || title.trim() === '') {
      throw new Error('Title is required and must be a non-empty string');
    }

    if (!industryId || !Number.isInteger(industryId) || industryId <= 0) {
      throw new Error('Industry ID is required and must be a positive integer');
    }

    if (!sectorId || !Number.isInteger(sectorId) || sectorId <= 0) {
      throw new Error('Sector ID is required and must be a positive integer');
    }

    if (!functionId || !Number.isInteger(functionId) || functionId <= 0) {
      throw new Error('Function ID is required and must be a positive integer');
    }

    if (!subFunctionId || !Number.isInteger(subFunctionId) || subFunctionId <= 0) {
      throw new Error('Sub Function ID is required and must be a positive integer');
    }

    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }

    const apiPath = '/CostEstimation/AddOrUpdateUseCase';
    console.log('Adding/Updating Use Case at URL:', apiPath);
    console.log('Use Case data:', useCaseData);
    // Prepare request body
    const requestBody = {
      id: id || 0,
      caseId: caseId.trim(),
      industryId: industryId,
      sectorId: sectorId,
      functionId: functionId,
      subFunctionId: subFunctionId,
      dataAILeverId: dataAILeverId || 0,
      dataAISubLeverId: dataAISubLeverId || 0,
      businessValueDriverId: businessValueDriverId || 0,
      businessSubValueDriverId: businessSubValueDriverId || 0,
      functionalValueDriverId: functionalValueDriverId || 0,
      functionalSubValueDriverId: functionalSubValueDriverId || 0,
      businessCapability: businessCapability ? businessCapability.trim() : '',
      dataAI: dataAI ? dataAI.trim() : '',
      title: title.trim(),
      description: description ? description.trim() : '',
      dataCapability: dataCapability ? dataCapability.trim() : '',
      dataTechnicalCapability: dataTechnicalCapability ? dataTechnicalCapability.trim() : '',
      aiCapability: aiCapability ? aiCapability.trim() : '',
      aiTechnicalCapability: aiTechnicalCapability ? aiTechnicalCapability.trim() : '',
      improvementActions: improvementActions ? improvementActions.trim() : '',
      indicator: indicator ? indicator.trim() : '',
      isActive: isActive
    };

    const { data: result, status: responseStatus } = await axiosInstance.post(apiPath, requestBody);
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`Failed to add/update Use Case: ${response.status} ${response.statusText}`);
    }


    console.log('AddOrUpdateUseCase response:', result);
    return result;
  } catch (error) {
    console.error('Error adding/updating Use Case:', error);
    throw error;
  }
};

// Delete Use Case API
export const deleteUseCase = async (id) => {
  try {
    // Validate parameter
    if (!id || !Number.isInteger(id) || id <= 0) {
      throw new Error('Invalid id: must be a positive integer');
    }

    const apiPath = `/CostEstimation/DeleteUseCase/${id}`;
    console.log('Deleting Use Case at URL:', apiPath);
    console.log('Use Case ID to delete:', id);
    const { data, status } = await axiosInstance.delete(apiPath);

    if (status === 204 || data == null || data === '') {
      return { success: true, message: 'Use Case deleted successfully' };
    }

    console.log('DeleteUseCase response:', data);
    return data;
  } catch (error) {
    console.error('Error deleting Use Case:', error);
    throw error;
  }
};

// Bulk Upload Use Cases API
export const bulkUploadUseCases = async (file) => {
  try {
    // Validate file parameter
    if (!file) {
      throw new Error('File is required for bulk upload');
    }

    // Validate file type
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel', // .xls
      'text/csv' // .csv
    ];

    if (!allowedTypes.includes(file.type)) {
      throw new Error('Invalid file type. Please upload an Excel (.xlsx, .xls) or CSV file');
    }

    // Create FormData for file upload
    const formData = new FormData();
    formData.append('file', file);

    const apiPath = '/CostEstimation/BulkUploadUseCases';
    console.log('Bulk uploading Use Cases to URL:', apiPath);
    console.log('File details:', {
      name: file.name,
      type: file.type,
      size: file.size
    });
    const { data: result, status: responseStatus } = await axiosInstance.post(apiPath, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    const response = { status: responseStatus, ok: responseStatus >= 200 && responseStatus < 300, statusText: '', headers: { get: () => 'application/json' }, json: async () => result, text: async () => (typeof result === 'string' ? result : JSON.stringify(result)) };

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.status === 401) {
      throw new Error('Unauthorized');
    }

    if (response.status === 400) {
      // Try to get validation error details
      let errorDetails = '';
      try {
        const errorResponse = await response.text();
        errorDetails = errorResponse;
        console.error('400 Error details:', errorResponse);
      } catch (e) {
        console.error('Could not parse error response:', e);
      }
      throw new Error(`Bad Request: ${errorDetails || 'Invalid file format or data'}`);
    }

    if (response.status === 500) {
      // Try to get more details about the 500 error
      let errorDetails = '';
      try {
        const errorResponse = await response.text();
        errorDetails = errorResponse;
        console.error('500 Error details:', errorResponse);
      } catch (e) {
        console.error('Could not parse error response:', e);
      }
      throw new Error(`Server error (500): ${errorDetails || 'Internal server error'}`);
    }

    if (!response.ok) {
      throw new Error(`Failed to bulk upload Use Cases: ${response.status} ${response.statusText}`);
    }


    console.log('BulkUploadUseCases response:', result);
    console.log('BulkUploadUseCases response data:', result.data);
    console.log('BulkUploadUseCases response message:', result.message);
    return result;
  } catch (error) {
    console.error('Error bulk uploading Use Cases:', error);
    throw error;
  }
};

// Get Capability Areas API (Data+AI capability categories for value estimation)
export const getCapabilityAreas = async (params = {}) => {
  try {
    const {
      searchTerm = '',
      isActive = true,
      page = 1,
      pageSize = 1000
    } = params;

    const queryParams = new URLSearchParams({
      ...(searchTerm && { searchTerm }),
      isActive: isActive.toString(),
      page: page.toString(),
      pageSize: pageSize.toString()
    });

    const { data: result } = await axiosInstance.get(
      `/CostEstimation/GetCapabilityAreas?${queryParams}`
    );
    return result;
  } catch (error) {
    console.error('Error fetching capability areas:', error);
    throw error;
  }
};